<template>
  <section-meta
    :count="pages.length"
    label="Pages"
    intro="All pages on this site affected by this card."
  >
    <page-item v-for="p in pages" :key="p.id" :page="p" class="ps-mt-6" />
  </section-meta>
</template>

<script>
import ButtonIcon from '@/components/buttons/ButtonIcon'
import SectionMeta from '@/components/SectionMeta'
import PageItem from '@/components/PageItem'
import '@/icons/add'

export default {
  name: 'CardSectionPages',
  props: {
    pages: {
      type: Array,
      default: () => []
    }
  },
  components: {
    PageItem,
    SectionMeta,
    ButtonIcon
  }
}
</script>
